import { APPLICATION } from "src/common/constants";

export const RESET_STORE = "RESET_STORE" as const;
export const FETCH_APPLICATION_DEPENDENCIES =
  `${APPLICATION}_FETCH_APPLICATION_DEPENDENCIES` as const;
export const REDIRECT_TO_LOGOUT = "REDIRECT_TO_LOGOUT";
export const SET_COLORS = `${APPLICATION}_SET_COLORS` as const;
export const SET_CAROUSELS = `${APPLICATION}_SET_CAROUSELS` as const;
export const SET_HEADER_STATE = `${APPLICATION}_SET_HEADER_STATE` as const;
export const SET_ASIDE_MENU = `${APPLICATION}_SET_ASIDE_MENU` as const;
export const SET_ASIDE_MENU_PREF =
  `${APPLICATION}_SET_ASIDE_MENU_PREF` as const;
export const SET_IS_GLOBAL_ERROR_MAP =
  `${APPLICATION}_SET_IS_GLOBAL_ERROR_MAP` as const;
export const SET_PAGE_ERROR = "SET_PAGE_ERROR";
export const SET_SMART_PORTAL_STATE =
  `${APPLICATION}_SET_SMART_PORTAL_STATE` as const;
export const LOCATION_CHANGE = `${APPLICATION}_LOCATION_CHANGE` as const;

export const fetchApplicationAndDependencies = () => ({
  type: FETCH_APPLICATION_DEPENDENCIES,
});
export const setPageError = () => ({ type: SET_PAGE_ERROR });
export const redirectToLogout = () => ({ type: REDIRECT_TO_LOGOUT });
export const setHeaderState = (state) => ({ type: SET_HEADER_STATE, state });
export const setAsideMenuCondensed = (payload) => ({
  type: SET_ASIDE_MENU,
  payload,
});
export const setAsideMenuCondensedPref = (payload) => ({
  type: SET_ASIDE_MENU_PREF,
  payload,
});

export const setColorSettings = (payload) => ({
  type: SET_COLORS,
  payload,
});

export const setCarousels = (payload) => ({
  type: SET_CAROUSELS,
  payload,
});

export const setIsGlobalRiskMap = () => ({ type: SET_IS_GLOBAL_ERROR_MAP });
export const setSmartPortalState = (state) => ({
  type: SET_SMART_PORTAL_STATE,
  state,
});

export const routeChanged = (payload) => ({
  type: LOCATION_CHANGE,
  payload,
});
